import { useSelector } from 'react-redux';

import { makeGetSubscriptionIsExpired, makeGetIsOnTrial } from 'selectors/billing';

import { useCurrentTeam } from 'shared-hooks/team';
import { useCurrentUser } from 'shared-hooks/user';

const getSubscriptionIsExpired = makeGetSubscriptionIsExpired();
const getIsOnTrial = makeGetIsOnTrial();

export const useSubscriptionIsExpired = () => {
    const currentTeam = useCurrentTeam();
    const isExpired = useSelector(() => getSubscriptionIsExpired(currentTeam, false));

    return isExpired;
};

export const useIsBillingOwner = () => {
    const currentTeam = useCurrentTeam();
    const currentUser = useCurrentUser();
    const isOnTrial = useSelector(() => getIsOnTrial(currentTeam));
    const isExpired = useSelector(() => getSubscriptionIsExpired(currentTeam, false));

    if (currentUser?.role === 'client') {
        return false;
    }

    return isOnTrial || isExpired || currentUser?.id === (currentTeam?.billing_owner || currentTeam?.owner);
};
